import { type SolidgateRequestPaymentResponse } from '@/types/payment';
import { useState, useEffect } from 'react';
import { throttle } from 'lodash';
import { SOLIDGATE_FORM_CARD_ENOUGH_WIDTH } from '@feature/payment/solidgate/config/solidgate.form.config';
import { useGetSolidgatePaymentCardsQuery } from '@/api/order';
import { usePaymentGatewayProvider } from '@feature/payment/usePaymentGatewayProvider';

/**
 * Special hook to detect if the viewport is enough to render the Solidgate payment form as Card ->
 * if not - render as Inline form
 */
export const useSolidgateConditions = () => {
  const [canRenderFormCard, setCanRenderFormCard] = useState(false);

  const { isSolidgate } = usePaymentGatewayProvider();

  const { data: cards } = useGetSolidgatePaymentCardsQuery();

  const canRenderPaymentCardsMenu = isSolidgate && !!cards?.length;

  useEffect(() => {
    const mediaQuery = window.matchMedia(`only screen and (min-width: ${SOLIDGATE_FORM_CARD_ENOUGH_WIDTH}px)`);
    const handleMediaQueryChange = (e: MediaQueryListEvent) => {
      setCanRenderFormCard(e.matches);
    };

    const throttleHandleMediaQueryChange = throttle(handleMediaQueryChange, 100);
    mediaQuery.addEventListener('change', throttleHandleMediaQueryChange);

    // Initial check
    setCanRenderFormCard(mediaQuery.matches);

    return () => {
      mediaQuery.removeEventListener('change', throttleHandleMediaQueryChange);
    };
  }, []);

  return { canRenderFormCard, canRenderPaymentCardsMenu, isSolidgate };
};

export const checkHasResign = (paymentDetails?: SolidgateRequestPaymentResponse): boolean => {
  if (!paymentDetails || !paymentDetails.resignPaymentForm) return false; // If paymentDetails is not provided, return false
  return Object.values(paymentDetails.resignPaymentForm).every(Boolean); // Check if all values in merchantDataResign are truthy
};
